import React__default from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme } from 'styled-components';
import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-BMy1SouZ.js';
import { S as StormContextProvider } from '../StormContext/StormContextProvider-BTxpbm54.js';
import { C as ConfigObserver } from './ConfigObserver-xpKlUycK.js';
import { u as useEffectiveTheme } from './hooks/useThemeMode/useEffectiveTheme-Ddty9300.js';

/**
 * Validates if the provided object is a valid theme (non-empty object) or theme function.
 * Prevents empty objects from being used as themes in JavaScript applications.
 */
const isValidTheme = obj => {
  if (typeof obj === 'function') return true;
  if (!obj || typeof obj !== 'object') return false;
  return Object.keys(obj).length > 0;
};

/**
 * Checks if the theme is a valid v4 Storm UI theme.
 * Prevents incompatible themes from older versions being used as parent themes.
 */
const isV4Theme = obj => !!obj && typeof obj === 'object' && obj.version === 4;
const ThemeProvider = ({
  children,
  theme,
  enableThemeModes = false
}) => {
  const parentTheme = /*#__PURE__*/useTheme();

  // Reactive theme that responds to user preference changes (light/dark/system)
  // Only computed when theme modes are enabled
  const dynamicTheme = useEffectiveTheme(enableThemeModes);

  // Final theme applied to styled-components context, resolved in priority order:
  // 1. Explicit theme prop (highest priority)
  // 2. Dynamic theme based on user preference (when theme modes enabled)
  // 3. Parent theme from nested context (if valid)
  // 4. Default light theme (fallback)
  const resolvedTheme = (isValidTheme(theme) ? theme : null) || dynamicTheme || (isV4Theme(parentTheme) ? parentTheme : null) || stormLightTheme;
  return /*#__PURE__*/React__default.createElement(ConfigObserver, null, config => /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: resolvedTheme
  }, /*#__PURE__*/React__default.createElement(StormContextProvider, null, children)));
};

export { ThemeProvider as T };
//# sourceMappingURL=ThemeProvider-BVCpt-_j.js.map
